import { Field, useFieldContext } from "@ark-ui/react/field";
import type { ComponentProps, PropsWithChildren } from "react";
import clsx from "clsx";

type HelperTextProps = Omit<ComponentProps<typeof Field.HelperText>, "className">;
type Props = PropsWithChildren<HelperTextProps>;

const HelperText = ({ children, ...rest }: Props) => {
  const { disabled } = useFieldContext();

  return (
    <Field.HelperText {...rest} className={clsx("text-label3", disabled ? "text-gray-300" : "text-gray-600")}>
      {children}
    </Field.HelperText>
  );
};

export default HelperText;
